let modals = require( './modals' );
let notices = require( './notices' );

let vibe_cake_masters_assignment = ( function ( $ ) {

	let max_file_size = 5, // This should be in MBs
		_URL,
		$form;

	let _init = function () {
		$form = $( '#assignment-form' );
		_URL  = window.URL || window.webkitURL;

		if ( $form.length > 0 ) {
			_attach_listeners();
		}
	};

	let _attach_listeners = function () {
		_detach_listeners();

		$( '#masters-modal-assignment-complete' ).on( 'vibe_cake_masters_closing', () => {
			window.location.reload();
		} );

		$form.find( 'input#file-upload' ).on( 'change', _add_photo );
		$form.find( 'input[name^="change_photo"]' ).on( 'change', _change_photo );
		$form.find( 'a.remove-photo' ).on( 'click', _remove_photo );
		$form.on( 'submit', _submit );
	};

	let _detach_listeners = function() {
		$form.find( 'input#file-upload' ).off( 'change', _add_photo );
		$form.find( 'input[name^="change_photo"]' ).off( 'change', _change_photo );
		$form.find( 'a.remove-photo' ).off( 'change', _remove_photo );
		$form.off( 'submit', _submit );
	};

	let _add_photo = function( e ) {
		$form.loading();

		let $input = $( this ),
			file   = $input[0].files[0],
			img    = new Image();

		img.src = _URL.createObjectURL( file );

		// Need to wait for the js image to load so that we can determine the width and height
		img.onload = function() {
			let data = new FormData();

			if ( ! _check_file_size( file ) ) {
				$input.val( null );
				$form.loaded();
				notices.add_notice( $form.find( '.notices-wrapper' ), 'error', 'The image that you have tried to upload is too large. The maximum file size is ' + max_file_size + ' MB.', false );
				_attach_listeners();
				return;
			}

			data.append( 'action', 'vibe_cake_masters_assignment_ajax_add_photo' );
			data.append( 'nonce', VibeCakeMastersScriptData.vibe_cake_masters_assignment_ajax_add_photo_nonce );
			data.append( 'lesson', $form.find( 'input[name="lesson"]' ).val() );
			data.append( 'attempt_num', $form.find( 'input[name="attempt_num"]' ).val() );
			data.append( 'image_width', this.width );
			data.append( 'image_height', this.height );

			img = null; // Delete image reference

			let form_data = new FormData( $form.get( 0 ) ),
				entries   = form_data.entries(),
				next;

			while ( ( next = entries.next() ) && next.done === false ) {
				if ( next.value[ 0 ] === $input.attr( 'name' ) ) {
					data.append( 'file', next.value[ 1 ] );
				}
			}

			$.ajax( {
				type: 'POST',
				url: VibeCakeMastersScriptData.ajaxurl,
				data: data,
				success: _add_photo_response,
				processData: false,
				contentType: false
			} );
		};
	};

	let _add_photo_response = function( response ) {
		if ( response.success ) {
			$form.find( '.add-photo' ).before( response.html );
		} else {
			notices.add_notice( $form.find( '.notices-wrapper' ), 'error', response.error, false );
		}

		if ( response.remove_media ) {
			// This is so that the input gets cleared if the image dimensions are too large
			$form.find( 'input#file-upload' ).val( null );
		}

		_attach_listeners();
		$form.loaded();
	};

	let _change_photo = function( e ) {
		_detach_listeners();
		$form.loading();

		let $input = $( this ),
			file   = $input[0].files[0],
			img    = new Image();

		img.src  = _URL.createObjectURL( file );

		// Need to wait for the js image to load so that we can determine the width and height
		img.onload = function() {
			let data = new FormData();

			if ( ! _check_file_size( file ) ) {
				$input.val( null );
				$form.loaded();
				notices.add_notice( $form.find( '.notices-wrapper' ), 'error', 'The image that you have tried to upload is too large. The maximum file size is ' + max_file_size + ' MB.', false );
				_attach_listeners();
				return;
			}

			data.append( 'action', 'vibe_cake_masters_assignment_ajax_change_photo' );
			data.append( 'nonce', VibeCakeMastersScriptData.vibe_cake_masters_assignment_ajax_change_photo_nonce );
			data.append( 'lesson', $form.find( 'input[name="lesson"]' ).val() );
			data.append( 'attempt_num', $form.find( 'input[name="attempt_num"]' ).val() );
			data.append( 'photo_key', $input.closest( '.assignment-photo' ).data( 'key' ) );
			data.append( 'image_width', this.width );
			data.append( 'image_height', this.height );

			let form_data = new FormData( $form.get( 0 ) ),
				entries = form_data.entries(),
				next;

			while ( (next = entries.next()) && next.done === false ) {
				if ( next.value[0] === $input.attr( 'name' ) ) {
					data.append( 'file', next.value[1] );
				}
			}

			$.ajax( {
				type : 'POST',
				url : VibeCakeMastersScriptData.ajaxurl,
				data : data,
				success : _change_photo_response,
				processData : false,
				contentType : false
			} );
		}
	};

	let _change_photo_response = function( response ) {
		if ( response.success ) {
			$form.find( '.assignment-photo-' + response.key ).replaceWith( response.html );
		} else {
			notices.add_notice( $form.find( '.notices-wrapper' ), 'error', response.error, false );
		}

		if ( response.remove_media ) {
			// This is so that the input gets cleared if the image dimensions are too large
			$form.find( '.assignment-photo-' + response.key + ' input[type="file"]' ).val( null );
		}

		_attach_listeners();
		$form.loaded();
	};

	let _remove_photo = function( e ) {
		e.preventDefault();
		e.stopImmediatePropagation();

		_detach_listeners();
		$form.loading();

		let $input = $( this );

		let data = new FormData();
		data.append( 'action', 'vibe_cake_masters_assignment_ajax_remove_photo' );
		data.append( 'nonce', VibeCakeMastersScriptData.vibe_cake_masters_assignment_ajax_remove_photo_nonce );
		data.append( 'lesson', $form.find( 'input[name="lesson"]' ).val() );
		data.append( 'attempt_num', $form.find( 'input[name="attempt_num"]' ).val() );
		data.append( 'photo_key', $input.closest( '.assignment-photo' ).data( 'key' ) );

		$.ajax( {
			type: 'POST',
			url: VibeCakeMastersScriptData.ajaxurl,
			data: data,
			success: _remove_photo_response,
			processData: false,
			contentType: false
		} );
	};

	let _remove_photo_response = function( response ) {
		if ( response.success ) {
			$form.find( '.assignment-photo-' + response.key ).remove();
		} else {
			notices.add_notice( $form.find( '.notices-wrapper' ), 'error', response.error, false );
		}

		_attach_listeners();
		$form.loaded();
	};

	let _submit = function( e ) {
		e.preventDefault();
		e.stopImmediatePropagation();

		_detach_listeners();
		$form.loading();

		let data = new FormData();
		data.append( 'action', 'vibe_cake_masters_assignment_ajax_submit' );
		data.append( 'nonce', VibeCakeMastersScriptData.vibe_cake_masters_assignment_ajax_submit_nonce );
		data.append( 'lesson', $form.find( 'input[name="lesson"]' ).val() );
		data.append( 'attempt_num', $form.find( 'input[name="attempt_num"]' ).val() );
		data.append( 'confirmation', $form.find( 'input[name="assignment_confirmation"]' ).is( ':checked' ) ? 'checked' : '' );

		$.ajax( {
			type: 'POST',
			url: VibeCakeMastersScriptData.ajaxurl,
			data: data,
			success: _submit_response,
			processData: false,
			contentType: false
		} );
	};

	let _submit_response = function( response ) {
		$form.loaded();

		if ( response.success ) {
			modals.open_modal( $( '#masters-modal-assignment-complete' ) );
		} else {
			notices.add_notice( $form.find( '.notices-wrapper' ), 'error', response.error, false );
			_attach_listeners();
		}
	};

	let _check_file_size = function ( file ) {
		let file_size = ( file.size / ( 1024 * 1024 ) ).toFixed( 2 );

		return max_file_size > file_size;
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = vibe_cake_masters_assignment;
